import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'ecase-public-documentation-dialog',
  templateUrl: './public-documentation-dialog.component.html'
})
export class PublicDocumentationDialogComponent {

  constructor(public dialogRef: MatDialogRef<PublicDocumentationDialogComponent>) {
  }

  onCloseDialog(): void {
    this.dialogRef.close();
  }
}
